import React from 'react';
import ChartIcon from '../../../../assets/Chart.png'
import PlaceIcon from '../../../../assets/place.png'
import RecentIcon from '../../../../assets/recent.png'
import StatsCard from '../../../../components/statsCard';
const StatsCards = () => {
    return (
        <div className="grid md:grid-cols-3 grid-cols-1 gap-4">
            <StatsCard bg={`bgprimary`} title={`Country Count`} value={`540.50`} icon={ChartIcon} />
            <StatsCard title={`Missing Countries`} value={`540.50`} icon={PlaceIcon} />
            <StatsCard title={`Recently Added Countries`} value={`540.50`} icon={RecentIcon} />
        </div>
    );
};

export default StatsCards;
